import {Location} from "@/read-model/Location";

export function calculateMapCenter(options: { leftOffset: number; bottomOffset: number }, newCenter: Location, nw: Location, se: Location): Location {
  const oldHeight = (se.lattitude - nw.lattitude);
  const newHeight = oldHeight * ((100 - options.bottomOffset) / 100)
  const oldWidth = (se.longitude - nw.longitude);
  const newWidth = oldWidth * ((100 - options.leftOffset) / 100)
  return new Location(
    newCenter.lattitude + (oldHeight - newHeight) / 2,
    newCenter.longitude - (oldWidth - newWidth) / 2,
  )
}
